const my_profile = {
  viewMyClubSeacretProfile: "Lihat Profil ClubSecret Saya", // translated
  viewMoreDetails: "Lihat Lebih Detail", // translated
  verifiedEmail: "Email Terverifikasi", // translated
  unverifiedEmail: "Email Belum Diverifikasi", // translated
  balance: "Keseimbangan", // translated
  pointsIn: "Poin Masuk", // translated
  pointsOut: "Menunjukkan", // translated
  topUp: "Isi Ulang", // translated
  pointsHistoryTable: "Tabel Riwayat Poin", // translated
  createdFrom: "Dibuat dari", // translated
  createdTo: "Dibuat hingga", // translated
  selectStatus: "Pilih status...", // translated
  searchByTitle: "Cari berdasarkan judul...", // translated
  pushNotifications: "Notifikasi Push",
  pushNotificationsDescription: "Terima notifikasi browser untuk pembaruan dan acara penting",
  pushNotificationsNotSupported: "Notifikasi push tidak didukung di browser ini",
  pushNotificationsDeniedMessage: "Izin notifikasi ditolak. Harap aktifkan notifikasi di pengaturan browser untuk menerima notifikasi push.",
  pushNotificationsEnabled: "Notifikasi push berhasil diaktifkan",
  pushNotificationsDisabled: "Notifikasi push berhasil dinonaktifkan",
  userInformationMissing: "Informasi pengguna hilang",
  failedToUpdatePushNotifications: "Gagal memperbarui pengaturan notifikasi push",
  notificationPermissionDenied: "Izin notifikasi ditolak. Harap aktifkan di pengaturan browser.",
  notificationPermissionRequired: "Izin notifikasi diperlukan untuk mengaktifkan notifikasi push",
  notSupported: "Tidak didukung",
  permissionDenied: "Izin ditolak",
  permissionNotRequested: "Izin tidak diminta",
  enabled: "Diaktifkan",
  disabled: "Dinonaktifkan",
};

export default my_profile;
